import { render, staticRenderFns } from "./TesteEneXBeSigrAnoGwh.vue?vue&type=template&id=5f2b6c7c&scoped=true&"
import script from "./TesteEneXBeSigrAnoGwh.vue?vue&type=script&lang=js&"
export * from "./TesteEneXBeSigrAnoGwh.vue?vue&type=script&lang=js&"
import style0 from "./TesteEneXBeSigrAnoGwh.vue?vue&type=style&index=0&id=5f2b6c7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b6c7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSimpleTable})
